import React from 'react';
import { Typography } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import Dashboard from './Dashboard';

const { Title, Paragraph } = Typography;

const NewCampDemo = () => {
  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={2}>
          <RocketOutlined /> Campaign Management
        </Title>
        <Paragraph>
          Manage your campaigns and create targeted advertising campaigns.
        </Paragraph>
      </div>

      <Dashboard />
    </div>
  );
};

export default NewCampDemo;
